// extracted by mini-css-extract-plugin
module.exports = {"btn":"facet-FacetShowAllBtn__btn--2sViT"};